class DetailsDisclosure extends HTMLElement {
  constructor() {
    super();
    this.mainDetailsToggle = this.querySelector('details');
    this.content = this.mainDetailsToggle.querySelector('summary').nextElementSibling;

    this.mainDetailsToggle.addEventListener('focusout', this.onFocusOut.bind(this));
    this.mainDetailsToggle.addEventListener('toggle', this.onToggle.bind(this));
  }

  onFocusOut() {
    setTimeout(() => {
      if (!this.contains(document.activeElement)) this.close();
    });
  }

  onToggle() {
    if (!this.animations) this.animations = this.content.getAnimations();

    if (this.mainDetailsToggle.hasAttribute('open')) {
      this.animations.forEach((animation) => animation.play());
    } else {
      this.animations.forEach((animation) => animation.cancel());
    }
  }

  close() {
    this.mainDetailsToggle.removeAttribute('open');
    this.mainDetailsToggle.querySelector('summary').setAttribute('aria-expanded', false);
  }
}

customElements.define('details-disclosure', DetailsDisclosure);

class HeaderMenu extends DetailsDisclosure {
  constructor() {
    super();
    this.header = document.querySelector('.header-wrapper');
    this.summaryElement = this.mainDetailsToggle.querySelector('summary');
    this.desktopMediaQuery = window.matchMedia('(min-width: 990px)');
    this.submenuDetails = this.mainDetailsToggle.querySelectorAll('.header__submenu details');

    this.mainDetailsToggle.addEventListener('mouseenter', this.onMouseEnter.bind(this));
    this.mainDetailsToggle.addEventListener('mouseleave', this.onMouseLeave.bind(this));
    this.summaryElement.addEventListener('click', this.onSummaryClick.bind(this));

    this.submenuDetails.forEach((details) => {
      details.addEventListener('mouseenter', () => this.openSubmenu(details));
      details.addEventListener('mouseleave', () => this.closeSubmenu(details));
    });
  }

  onToggle() {
    if (!this.header) return;
    this.header.preventHide = this.mainDetailsToggle.open;

    if (document.documentElement.style.getPropertyValue('--header-bottom-position-desktop') !== '') return;
    document.documentElement.style.setProperty(
      '--header-bottom-position-desktop',
      `${Math.floor(this.header.getBoundingClientRect().bottom)}px`
    );
  }

  onMouseEnter() {
    if (!this.desktopMediaQuery.matches) return;
    window.clearTimeout(this.closeTimeout);
    this.mainDetailsToggle.classList.add('menu-opening');
    this.mainDetailsToggle.setAttribute('open', '');
    this.summaryElement.setAttribute('aria-expanded', true);
  }

  onMouseLeave() {
    if (!this.desktopMediaQuery.matches) return;
    this.closeTimeout = window.setTimeout(() => {
      this.close();
    }, 80);
  }

  onSummaryClick(event) {
    if (!this.desktopMediaQuery.matches || event.detail === 0) return;
    event.preventDefault();
  }

  openSubmenu(details) {
    if (!this.desktopMediaQuery.matches) return;
    window.clearTimeout(this.closeTimeout);
    details.classList.add('menu-opening');
    details.setAttribute('open', '');
    details.querySelector('summary')?.setAttribute('aria-expanded', true);
    this.positionSubmenu(details);
  }

  closeSubmenu(details) {
    if (!this.desktopMediaQuery.matches) return;
    details.classList.remove('menu-opening', 'submenu-open-left', 'submenu-open-right');
    details.removeAttribute('open');
    details.querySelector('summary')?.setAttribute('aria-expanded', false);
  }

  positionSubmenu(details) {
    const submenu = details.querySelector(':scope > .header__submenu');
    if (!submenu) return;

    details.classList.remove('submenu-open-left', 'submenu-open-right');

    const submenuWidth = submenu.scrollWidth || submenu.offsetWidth || 220;
    const detailsRect = details.getBoundingClientRect();
    const viewportPadding = 16;
    const shouldOpenLeft = detailsRect.right + submenuWidth > window.innerWidth - viewportPadding
      && detailsRect.left > submenuWidth * 0.6;

    details.classList.add(shouldOpenLeft ? 'submenu-open-left' : 'submenu-open-right');
  }

  close() {
    super.close();
    this.mainDetailsToggle.classList.remove('menu-opening');
    this.submenuDetails.forEach((details) => {
      details.classList.remove('menu-opening', 'submenu-open-left', 'submenu-open-right');
      details.removeAttribute('open');
      details.querySelector('summary')?.setAttribute('aria-expanded', false);
    });
  }
}

customElements.define('header-menu', HeaderMenu);
